import pxToRem from '@/theme/helpers/pxToRem';
import styled from 'styled-components';
import StyledPage from '../styles';
import typography from '@/theme/typography';
import {sizePx} from '@/theme/helpers/size';

export const StyledProductPage = styled(StyledPage)`
  h1 {
    span {
      display: block;
      margin-bottom: ${sizePx(5)};
    }

    // TODO: remove classes once page is moved fully to styled-components
    .title {
      ${typography.Art}
    }

    .subtitle {
      ${typography.Body1}
    }
  }
`;

export const StyledBtnRow = styled.div`
  margin: ${pxToRem(5)} 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
